import PropTypes from 'prop-types'
import { BarContainer, LeftContainer } from '../styled-components.js'

const ToolbarLeftContainer = ({ children }) => {
  return (
    <LeftContainer>
      <BarContainer>{children}</BarContainer>
    </LeftContainer>
  )
}

ToolbarLeftContainer.propTypes = {
  children: PropTypes.node.isRequired
}

export default ToolbarLeftContainer
